import React, { useEffect, useState } from "react";
import { Flex, Loader, Text, Popup, Button, ButtonProps } from "@fluentui/react-northstar";
import { AadUserAvatar } from "./AadUserAvatar";
import { AadUserContactButtons } from "./AadUserContactButtons";
import { linkButtonStyles, RegularText } from "shared/components";
import { FullScreenPanel } from "./FullScreenPanel";
import MsGraph from "../ms-graph/MsGraph";
import { AadUserDetailsModel } from "../models";
import { constants } from "shared/constants";

export interface AadUserDetailsProps {
    fullName?: string;
    email?: string;
    phoneNumber?: string;
    mobileClient?: boolean;
}

export const AadUserDetails: React.FC<AadUserDetailsProps> = ({ fullName, email, phoneNumber, mobileClient }) => {
    const [loading, setLoading] = useState(fullName && email ? true : false);
    const [aadUserDetails, setAadUserDetails] = useState<AadUserDetailsModel | null>();
    const [mobileFullScreenViewOpened, setMobileFullScreenViewOpened] = useState(false);

    useEffect(() => {
        const init = async () => {
            if (fullName && email) {
                const result = await MsGraph.tryGetAadUserDetails(email);
                if (result.isSuccess) {
                    setAadUserDetails(result.data!);
                } else {
                    setAadUserDetails(null);
                }
                setLoading(false);
            }
        };

        init();
    }, []);

    if (loading) {
        return (
            <Flex gap="gap.small">
                <Text>{fullName}</Text>
                <Loader size="smallest" inline delay={2000} />
            </Flex>
        );
    }

    if (!fullName) {
        return <RegularText content={constants.noValue} />;
    }

    if (!phoneNumber && !email) {
        return <RegularText content={fullName} />;
    }

    const commonButtonProps: ButtonProps = {
        className: linkButtonStyles,
        text: true,
        content: fullName,
        styles: { cursor: "default" },
    };

    const Details = () => (
        <Flex column gap="gap.medium">
            <AadUserAvatar
                base64Photo={aadUserDetails?.base64Photo}
                fullName={fullName}
                email={email}
                phoneNumber={phoneNumber}
                vertical={mobileClient}
                presence={aadUserDetails?.presence}
            />
            <AadUserContactButtons
                email={email}
                phoneNumber={phoneNumber}
                hasMobileDeviceCapabilities={mobileClient}
                userFoundInAad={aadUserDetails !== undefined && aadUserDetails !== null}
                centered={mobileClient}
            />
        </Flex>
    );

    if (mobileClient) {
        return (
            <>
                <Button {...commonButtonProps} onClick={() => setMobileFullScreenViewOpened(true)} />
                {mobileFullScreenViewOpened && (
                    <FullScreenPanel onClose={() => setMobileFullScreenViewOpened(false)}>
                        <Details />
                    </FullScreenPanel>
                )}
            </>
        );
    }

    return (
        <Popup
            trigger={<Button {...commonButtonProps} />}
            content={<Details />}
            on="hover"
            position="after"
            pointing
            mouseLeaveDelay={0}
        />
    );
};
